export default "__VITE_ASSET__BJQftIGV__"